import styles from "./TransactionList.module.scss";
import {Transaction} from "./Transaction";
import React from "react";

class TransactionList extends React.Component{

    render() {
        return (
            <div className={styles.transactions}>
                {this.props.transactions && this.props.transactions.map(transaction => {
                    return (
                        <Transaction item={transaction} key={transaction.id}
                                     onClick={this.props.handleTransactionClick}/>
                    )
                })}
            </div>
        );
    }
}

export default TransactionList;